import React from 'react';
import { Sheet } from '../../../../../mobile/structural/sheet/Sheet';
import useSheet from '../../../../../mobile/structural/sheet/hooks/useSheet';
import { SheetId } from '../../../../../mobile/structural/sheet/sheetTypes';
import TaskDueDatePopupContent from './TaskDueDatePopupContent';
import { holdFocusWithoutKeyboard } from '../../../../../mobile/boardsPage/editing/touchScreenFocusUtils';

import './MobileDueDateSheet.scss';

const MobileDueDateSheet = ({ elementId }: { elementId: string }) => {
    const sheetProps = useSheet(SheetId.DueDateTool, elementId);

    return (
        <Sheet className="due-date-tool" {...sheetProps} onCloseTransitionStart={holdFocusWithoutKeyboard}>
            <Sheet.Overlay />
            <Sheet.Panel>
                <Sheet.Content>
                    <TaskDueDatePopupContent closePopup={sheetProps.closeSheet} elementId={elementId} />
                </Sheet.Content>
            </Sheet.Panel>
        </Sheet>
    );
};

export default MobileDueDateSheet;
